export default __webpack_public_path__ + "static/media/check.ea854a7f.png";